import {createContext} from 'react';

import {ChartToolbarHighlight, ChartToolbarHighlights} from '../types/ChartToolbarHighlight';
import {ChartToolbarHighlightMode} from '../types/ChartToolbarHighlightMode';

export type ChartToolbarContextType = {
  highlights: ChartToolbarHighlights;
  highlightMode: ChartToolbarHighlightMode;
  effectiveHighlightMode: ChartToolbarHighlightMode;
  selectedSellerId: string | null;
  setHighlightMode: (mode: ChartToolbarHighlightMode) => void;
  setSelectedSellerId: (sellerId: string | null) => void;
  toggleHighlight: (highlight: ChartToolbarHighlight) => void;
  isHighlightEnabled: (highlight: ChartToolbarHighlight) => boolean;
};

export const ChartToolbarContext = createContext<ChartToolbarContextType | null>(null);
